var map = {
	"./banking.PNG": 495,
	"./discordBot.png": 723,
	"./disinfectantRobot.png": 923,
	"./identity-generator.PNG": 567,
	"./movie-app.jpg": 624,
	"./pythonProjects.png": 280,
	"./react-aws.png": 749,
	"./react-native-app.png": 914,
	"./smartGlasses.png": 866,
	"./taskmanager.jpg": 105,
	"./zaid.png": 937
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 252;